import React, { useState, useContext } from "react";
import { Modal, Row, Typography, Input, Form, message } from "antd";
import { platformApi } from "../../../../../../api";
import { withRouter } from "react-router-dom";
import { ContextAPI } from "../../../../../../ContextAPI";

const { Item } = Form;
const { Title } = Typography;

const TestSMSForm = (props) => {
  const [loading, setLoading] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);

  const { form, open, close, templates, sms, id } = props;
  const { getFieldDecorator, validateFields, setFieldsValue } = form;

  const resolveTemplates = () => {
    if (Array.isArray(templates) && templates.length) return templates;
    if (Array.isArray(sms) && sms.length) return sms;
    if (typeof sms === "string" && sms.trim()) {
      try {
        const parsed = JSON.parse(sms);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        return [sms];
      }
    }
    return [];
  };

  const handleSubmit = () => {
    validateFields((validationError, values) => {
      if (validationError === null) {
        const selectedTemplates = resolveTemplates();
        if (!selectedTemplates.length) {
          message.error("Select a WhatsApp template first");
          return;
        }
        setLoading(true);
        platformApi
          .post("/api/sendSms/test", {
            phone: values.number,
            templates: selectedTemplates,
            sms: JSON.stringify(selectedTemplates),
            senderId: id,
          })
          .then((res) => {
            setLoading(false);
            if (res.data.code === 200) {
              let resp = res.data.response;
              if (resp.code === 200) {
                message.success(resp.message || "Test WhatsApp sent");
                close();
              } else {
                message.error(resp.message || "Error in sending test WhatsApp");
              }
            } else if (res.data.code === 401) {
              message.error(res.data.message);
            } else {
              message.error("Error in sending test WhatsApp");
            }
          })
          .catch(() => {
            setLoading(false);
            message.error("Error in sending test WhatsApp");
          });
      }
    });
  };

  const clearFields = () => {
    form.resetFields();
  };

  return (
    <Modal
      title={<Title level={4}>Test WhatsApp</Title>}
      visible={open}
      onCancel={() => {
        clearFields();
        close();
      }}
      onOk={() => handleSubmit()}
      cancelText="Cancel"
      okText="Send"
      confirmLoading={loading}
    >
      <Form>
        <Row>
          <Item label="Number" colon={false}>
            {getFieldDecorator("number", {
              rules: [
                { required: true, message: "Please enter phone number" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit phone number",
                },
              ],
            })(
              <Input
                placeholder="Enter 10-digit phone number"
                maxLength={10}
                onKeyUp={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  setFieldsValue({
                    number: value,
                  });
                }}
                onInput={(event) => {
                  const rawValue = event.target.value;
                  const filteredValue = rawValue.replace(/[^0-9]/g, "");
                  if (filteredValue !== rawValue) {
                    event.target.value = filteredValue;
                    setFieldsValue({
                      number: filteredValue,
                    });
                  }
                }}
              />
            )}
          </Item>
        </Row>
      </Form>
      <br />
    </Modal>
  );
};

const WrappedAccessoriesModal = Form.create({ name: "test_sms" })(TestSMSForm);
export default withRouter(WrappedAccessoriesModal);
